<template>
  <div class="articlelist-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
     <table-search
       :style="{ float: 'right' }"
       @onSearch="onSearch"
       @onChangeStatus="onChangeStatus"
       @editAndAdd="editAndAdd"
     />
    </div>
    <div class="global-table-container">
 <!--     <div class="recommend-btn-container">
        <a-button
          type="danger"
          class="recommend-btn"
          :loading="delLoading"
          @click="handleDelete"
        >
          删除
        </a-button>
        <span
          v-show="isShowError"
          class="errorMsg"
        >请至少选择一项</span>
      </div> -->

      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"

        @change="changePage"
      >
	  <template
	    slot="type"
	    slot-scope="text, record"
	  >
	    {{ record.type===1?'新闻资讯':'常见问题' }}
	  </template>
        <template
          slot="thumbnail"
          slot-scope="text, record"
        >
		
          <img
            :src="record.thumbnail_url"
            alt=""
            width="80px"
            height="40px"
			@click="prew(record.thumbnail_url)"
          >
        </template>
        <template
          slot="jump_url"
          slot-scope="text, record"
        >
          <a @click="()=>handleChange(record)">查看</a>
        </template>
        <template
          slot="status"
          slot-scope="text, record"
        >
          {{ record.data.status===1?'显示':'隐藏' }}
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
	
	<a-modal class="client-modal-wrapper" width="702px" :mask-closable="false" @cancel="onCancelImg" :visible="isVisibleImg" :footer="null">
		<div style="text-align: center;">
			<img :src="url"  style="width: 100%;">
		</div>
		<form-button
		:showMsg="false"
		submitText="确定"
		  @onCancel="onCancelImg"
		  @onSubmit="onCancelImg"
		  
		/>
	</a-modal>
    <details-modal
      :visible="visibleDetails"
      :src="detailUrl"
      @onCancel="onCancelDetail"
    >
      <form-button
        :show-msg="false"
        submit-text="确定"
        @onCancel="onCancelDetail"
        @onSubmit="onCancelDetail"
      />
    </details-modal>
  </div>
</template>
<script>
import {columnsCompany, columnsService} from './data/index';
import TableSearch from './components/search';
import DetailsModal from './modal/detailsModal.vue';
export default {
  components: {TableSearch, DetailsModal},
  data() {
    return {
		isVisibleImg:false,
		url:'',
      columns: [],
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      title: '',
      visible: false,
      id: '',
      isShowError: false,
      selectedRowKeys: [],
      delLoading: false,
      keyword: undefined,
      wstatus: '-1',
      companyData: [],
      visibleDetails: false,
      detailUrl: '',
    };
  },
  async mounted() {
	  this.columns=columnsService;
	  await this.getCompanyList();
    // if (this.$store.state.user.role === 1) {
      
    // } else {
    //   this.columns = columnsService;
    // }
    // 获取表格数据
    await this.getTableData(
      {obj_type: '1',
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
        wstatus: this.wstatus,
      });
  },
  methods: {
	  prew(url){
	  		  this.isVisibleImg=true;
	  		  this.url=url
	  },
	  onCancelImg(){
	  		  this.isVisibleImg=false;
	  },
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post('/Company/getCooperationCompanyList');
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
      }
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/portalPost/getList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            company: this.companyData.length>0? this.companyData.find((list)=>list.id===item.company_id).companyInfo.qichacha_name:undefined,
            name: item.name,
            admin_name: item.admin_name,
            list_order: item.list_order,
            hits: item.hits,
			      type: item.type,
            likes: item.likes,
            jump_url: item.jump_url,
			      // product_info_title: item.product_info.title,
            thumbnail_url: item.thumbnail_url,
            update_time: this.$Format(item.update_time),
            create_time: this.$Format(item.create_time),
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
		console.log(data)
      }
    },
    // 搜索
    onSearch(value) {
      this.current=1;
      this.keyword=value;
      this.getTableData(
        {obj_type: '1',
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
        });
    },
    // 选择状态
    onChangeStatus(value){
      console.log('onChangeStatus -> value', value);
      this.current=1;
      this.wstatus=value;
      this.getTableData(
        {obj_type: '1',
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
        });
    },
    // 编辑或新增
    editAndAdd(record) {
      console.log('editAndAdd -> record', record);
      if(record){
        // this.data=record;
        this.$router.push({path: '/article/edit', query: {id: record.id}});
      }else{
        this.$router.push({path: '/article/add'});
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.hospitalModalForm.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            console.log(values);
            this.btnIsLoading=true;
            let result=await this.$http.post('/Customer/update', {type: this.type, id: this.id, ...values});
            this.btnIsLoading=false;
            if(result.data.status===1){
              this.$message.success('操作成功！');
              this.getTableData(
                {obj_type: '1',
                  page: this.current,
                  pageSize: this.pageSize,
                  keyword: this.keyword,
                  wstatus: this.wstatus,
                  polymorphic_type: this.polymorphic_type,
                  company_id: this.company_id,
                  group_id: this.group_id,
                  start_time: this.start_time?this.$Date(this.start_time):undefined,
                  end_time: this.end_time?this.$Date(this.end_time):undefined,
                });
              this.hospitalVisible = false;
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 查看文章详情
    handleChange(record){
      this.detailUrl=record.jump_url;
      this.visibleDetails=true;
    },
    // 取消查看
    onCancelDetail(){
      this.visibleDetails=false;
    },
    // 删除单个
    async onDelete(record) {
      let result=await this.$http.post('/portalPost/postDel', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows){
      this.selectedRowKeys = selectedRowKeys;
    },
    // 批量删除
    async handleDelete() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.delLoading=true;
      let result = await this.$http.post('/portalPost/postDelMore', {
        ids: this.selectedRowKeys,
      });
      this.delLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.isShowError=false;
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData(
        {obj_type: '1',
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          group_id: this.group_id,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.articlelist-container {
  .recommend-btn-container {
    margin-bottom: 10px;
    .recommend-btn {
      margin-right: 10px;
    }
    .errorMsg{
      color: red;
      font-size: 16px;
      margin-left: 10px;
    }
  }
}
</style>
